/* gudsleep NeckReset™ — buy box behaviour (pack selection, gallery, sticky bar) */
(function () {
  function init(root) {
    if (!root || root.dataset.nrReady) return;
    root.dataset.nrReady = '1';

    var form = root.querySelector('[data-nr-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var priceEls = document.querySelectorAll('[data-nr-price]');
    var compareEl = root.querySelector('[data-nr-compare]');
    var atc = root.querySelector('[data-nr-atc]');
    var atcLabel = root.querySelector('[data-nr-atc-label]');
    var packs = root.querySelectorAll('.nr-pack');

    packs.forEach(function (pack) {
      var input = pack.querySelector('input');
      if (!input) return;
      input.addEventListener('change', function () {
        packs.forEach(function (p) { p.classList.remove('is-active'); });
        pack.classList.add('is-active');
        if (idInput) idInput.value = input.value;
        priceEls.forEach(function (el) { el.textContent = input.dataset.price; });
        if (compareEl) compareEl.textContent = input.dataset.compare || '';
        var stock = root.querySelector('[data-nr-stock]');
        if (stock) {
          var q = parseInt(input.dataset.qty, 10), low = parseInt(stock.dataset.low, 10) || 0;
          var isLow = input.dataset.tracked === '1' && q > 0 && q <= low;
          var main = stock.querySelector('[data-nr-stock-main]'), sub = stock.querySelector('[data-nr-stock-sub]');
          if (main) main.textContent = isLow ? stock.dataset.lowText.replace('[n]', q) : stock.dataset.in;
          if (sub) sub.textContent = isLow ? stock.dataset.lowSub : stock.dataset.inSub;
        }
        var available = input.dataset.available === 'true';
        if (atc) atc.disabled = !available;
        if (atcLabel) atcLabel.textContent = available ? atcLabel.dataset.label : atcLabel.dataset.soldout;
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', input.value);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      });
    });

    var main = root.querySelector('[data-nr-main] img');
    root.querySelectorAll('.nr-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        main.src = thumb.dataset.src;
        main.removeAttribute('srcset');
        main.alt = thumb.dataset.alt || '';
        root.querySelectorAll('.nr-thumb').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        var extras = root.querySelectorAll('[data-nr-addon]:checked');
        if (!extras.length || !window.fetch) return;
        e.preventDefault();
        var items = [{ id: Number(idInput.value), quantity: 1 }];
        extras.forEach(function (x) { items.push({ id: Number(x.value), quantity: 1 }); });
        var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        if (atc) atc.disabled = true;
        fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = rootUrl + 'cart';
        }).catch(function () { if (atc) atc.disabled = false; form.submit(); });
      });
    }

    var sticky = document.querySelector('[data-nr-sticky]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var pastIt = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', pastIt);
        });
      }).observe(atc);
    }
  }

  function addWorkingDays(start, n) {
    var d = new Date(start.getTime());
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }
  function fmt(d) {
    try { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }).replace(',', ''); }
    catch (e) { return d.toDateString().slice(0, 10); }
  }
  function etas() {
    document.querySelectorAll('[data-nr-eta]').forEach(function (el) {
      var min = parseInt(el.dataset.min, 10) || 10, max = parseInt(el.dataset.max, 10) || min;
      if (max < min) max = min;
      var now = new Date();
      var from = el.querySelector('[data-nr-eta-from]'), to = el.querySelector('[data-nr-eta-to]');
      if (from) from.textContent = fmt(addWorkingDays(now, min));
      if (to) to.textContent = fmt(addWorkingDays(now, max));
    });
  }

  function boot() { document.querySelectorAll('[data-nr-buy]').forEach(init); etas(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();